@if (!item.hidden) {
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [queryParams]="item.queryParams || {}"
      #rla="routerLinkActive"
      [attr.aria-current]="rla.isActive ? 'page' : null"
      [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="item.function($event, item)" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="item.function($event, item)"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="item.function($event, item)"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  @if (item.id === 'offered-by' && (item?.image?.url || !item?.disabled)) {
    <button class="nav-item__logo-button"
      data-e2e="nav-item-trigger-callback"
      [disabled]="item.disabled"
      (click)="item.callBack()">
      @if (item.translate || (item.icon && !item.disabled)) {
        <div class="nav-item__logo-button-header">
          @if (item?.translate) {
            <span class="nav-item__logo-button-label"
              [translate]="item?.translate">
            </span>
          }
          @if (item?.icon && !item?.disabled) {
            <mat-icon class="nav-item__logo-button-icon"
              [svgIcon]="item?.icon">
            </mat-icon>
          }
        </div>
      }
      @if (item?.image?.url) {
        <img class="nav-item__logo-button-image"
          [src]="item?.image?.url"
          [alt]="item?.image?.alt ? item?.image?.alt : ''" />
        }
      </button>
    }
    <ng-template #itemContent>
      @if (item.icon && !item.hasOwnProperty('displayIcon') || (item.hasOwnProperty('displayIcon') && item['displayIcon'])) {
        <mat-icon class="nav-link-icon svg-icon" [svgIcon]="item.icon"></mat-icon>
      }
      <span class="nav-link-title" [translate]="item.translate"></span>
      @if (item.badge) {
        <span class="nav-link-badge" [translate]="item.badge.translate"
          [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
          {{item.badge.title}}
        </span>
      }
    </ng-template>
  }
